import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";
import { Menu } from "../../types/Menu";
import { Box } from "../Box";
import { DesktopMenuDropDownItem } from "../DesktopMenuDropDownItem";
import { Flex } from "../Flex";
import { MenuItemLink } from "../MenuItemLink";
import { getBorderBottom, getMarginBottom } from "./_/selectedMenuItem";

interface Props {
  currentPath: string;
}

const StyledBox = styled(Box)`
  border-color: #0dcf5a;
  &:hover {
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: -2px;
  }
`;

export const DesktopMenu: React.FC<Props & Menu> = ({ currentPath, menu }) => (
  <Flex
    justifyContent="space-between"
    alignItems="center"
    as="nav"
    data-testid="menu-desktop"
    borderBottom="1px solid"
    borderColor="greyDark"
  >
    {menu.map(item =>
      isEmpty(item.subMenu) ? (
        <StyledBox key={item.title} p={2} borderBottom={getBorderBottom(currentPath, item)} mb={getMarginBottom(currentPath, item)}>
          <MenuItemLink to={item.url} color="white">
            {item.title}
          </MenuItemLink>
        </StyledBox>
      ) : (
        <DesktopMenuDropDownItem key={item.title} currentPath={currentPath} {...item} />
      ),
    )}
  </Flex>
);
